export default __webpack_public_path__ + "static/media/bg.c097bed4.jpg";